// Keep routing and walkthrough tests on the same read-only screen allowlist.
export const tourPatientScreens = [
  'list', 'dashboard', 'dashboard-risk', 'dashboard-chats', 'dashboard-conversation',
  'dashboard-wellness-scores', 'dashboard-wellness-trends', 'dashboard-wellness', 'dashboard-assessments', 'profile', 'consultations',
  'files', 'detail', 'recording', 'transcript', 'recordings-upload', 'recordings-ready',
  'report', 'generate', 'result', 'share',
  'home-practice-client', 'home-practice-source', 'home-practice-write',
  'home-practice-setup', 'home-practice-result', 'home-practice-files',
  'home-practice-share', 'home-practice-complete',
];

export function getTourPatientScreen(search) {
  const params = new URLSearchParams(search);
  const tour = params.get('tour');
  const demo = params.get('demo');
  if (tour === 'home-practice') {
    return tourPatientScreens.includes(demo) && demo.startsWith('home-practice-') ? demo : 'home-practice-client';
  }
  if (tour === 'patient') return tourPatientScreens.includes(demo) ? demo : 'list';
  return tour === 'preview' && tourPatientScreens.includes(demo) ? demo : null;
}
